import React from 'react';
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import ReactPaginate from "react-paginate";
import Button from "../button/button";

export const MainPaginate = ({ handlePageClick, pageCount }) => (
	<div className="flex justify-center items-center py-10">
		<ReactPaginate
			breakLabel="..."
			onPageChange={handlePageClick}
			pageRangeDisplayed={5}
			pageCount={pageCount}
			renderOnZeroPageCount={null}
			pageClassName="h-10 w-10 flex items-center justify-center rounded-full text-xl font-medium manrope border border-main text-main mx-2 cursor-pointer"
			className="flex items-center justify-center"
			previousClassName="hidden"
			nextClassName="hidden"
			activeClassName="bg-[#30388F] text-white"
		/>
	</div>
);

export const LoadMore = ({ handleLoadMore, next, loading }) => {
	return (
		<>
			{!next ? (
				""
			) : (
				<Button
					onClick={handleLoadMore}
					title={loading ? "Loading..." : "Load More"}
					loading={loading}
					css="mx-auto"
					type={"button"}
					buttonType={"primary"}
					width={"w"}
				/>
			)}
		</>
	);
};


const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const pageNumbers = [];

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  return (
    <nav className="flex justify-center items-center space-x-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className={`px-4 py-2 rounded-md flex ${
          currentPage === 1 ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-500 text-white'
        }`}
      >
        <AiOutlineArrowLeft className='icon' size={24} />
        Previous
      </button>
      <ul className="inline-flex space-x-2">
        {pageNumbers.map((page) => (
          <li key={page}>
            <button
              className={`px-4 py-2 text-sm font-medium ${
                page === currentPage
                  ? 'bg-blue-500 text-white'
                  : 'bg-white text-blue-500'
              } rounded-md`}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          </li>
        ))}
      </ul>
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className={`px-4 py-2 rounded-md flex ${
          currentPage === totalPages ? 'bg-gray-300 text-gray-500 cursor-not-allowed' : 'bg-blue-500 text-white'
        }`}
      >
        Next
      <AiOutlineArrowRight  className='icon ml-1' size={24}/>
      </button>
    </nav>
          
  );
};

export default Pagination;
